import { S as Swiper } from './swiper-core-DH3mE4MZ.js';
import { M as Mousewheel } from './mousewheel-DmZLF0Pd.js';
import { A as A11y } from './a11y-DWSxD09z.js';

class PredictiveSearchSuggestions extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Mousewheel],
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesOffsetAfter: -24,
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
    });
  }
}

customElements.define('predictive-search-suggestions', PredictiveSearchSuggestions);
